import type { StageParameters } from '../stage/stage-parameters';
import type { AppConfig, AppEnvironment } from './app';
import { getAppEnvironment } from './app';
import type { ConfigurationParameter } from './configuration-parameter';
import type { AuthorizationEnvSetting } from './settings/authorization';
import { getAuthorizationConfig } from './settings/authorization';

// applies to all mobile apps
export type MobileAppEnvironment = AppEnvironment & {
  authorizationConfig: AuthorizationEnvSetting;
  appVersionApiUrl: string;
  baseUrl: string;
};

export type MobileAppConfig = (
  AppConfig &
  ConfigurationParameter<typeof getAuthorizationConfig>
);

export const getMobileAppEnvironment = (
  stageParams: StageParameters,
  config: MobileAppConfig,
): MobileAppEnvironment => ({
  ...getAppEnvironment(stageParams, config),
  appVersionApiUrl: stageParams.baseUrl + 'vert-api/api/mobile-app-version',
  authorizationConfig: getAuthorizationConfig(stageParams, config),
  baseUrl: stageParams.baseUrl,
});

